<!--
 某个地块的种植计划详细，按日历显示
-->
<template>
  <div>
    <p v-if="!show">请先选择计划开始日期和种植方案</p>
    <div id="plan-detail" v-else>
      <el-calendar v-model="chooseDate">
        <template slot="dateCell" slot-scope="{ date, data }">
          <div style="height: 100%">
            <div style="font-size: 20px" :class="data.type">
              {{ date.format('d') }}
              {{ data.day === todayString ? '今天' : '' }}
            </div>
            <!-- 阶段子组件 -->
            <phase-cell :phase="phase(date)">
              <!--  阶段中用插槽装载一个“工作安排”的按钮，因为这个按钮需要此组件的上下文，如日期、地块等。 -->
              <el-button
                v-if="planning"
                type="success"
                size="mini"
                @click="work(date)"
              >
                工作安排
              </el-button>
            </phase-cell>
            {{a}}
            <i v-if="taskFlag(date)" class="el-icon-warning"></i>
            <!-- 专家建议的弹出框 -->
            <el-popover
              v-if="suggests[data.day]"
              placement="top-start"
              width="300"
              trigger="hover"
            >
              <el-tag slot="reference" size="small" type="success" round>
                建议
              </el-tag>
              <div>
                {{ data.day }}
                <ul>
                  <li v-for="s in suggests[data.day]" :key="s">
                    {{ s }}
                  </li>
                </ul>
              </div>
            </el-popover>
          </div>
        </template>
      </el-calendar>
    </div>
  </div>
</template>
<script>
import PhaseCell from './PlanDetailCalendarCell.vue'
import { getPhasesOfPlan, getSuggestsOfPlan } from '@/api/plan2.js'
import { taskDateGet} from '@/api/plan-list.js'
export default {
  name: 'PlanDetailCalendar',
  components: { PhaseCell },
  data() {
    return {
      /**
       * 今天的日期字符串，形如2021-08-28，用于过滤器比对
       */
      todayString: new Date().format('yyyy-MM-dd'),
      /**
       * 种植计划对象。如果其中的planId无效，则表示实际上没有种植计划
       */
      plan: undefined,
      /**
       * 当前是否已有种植计划
       */
      planning: false,
      chooseDate: '',
      /**
       * 专家建议。形如 { '2021-08-28': ['建议除草', '建议施肥'], ...}
       */
      suggests: {},
      /**
       * 种植阶段
       */
      phases: [],
      a:undefined
    }
  },
  mounted() {

  },
  computed: {
    taskFlag() {
      return  function (date) {
        let that=this
         taskDateGet(that.plan.landId,new Date(date).valueOf()).then((r)=>{
           that.a=r.adata
           console.log(that.a)
         })

      }

       // return function (date){
       //  let that=this
       //   let b=false
       //   async function isTask(d) {
       //     let a= await   taskDateGet(that.plan.landId,new Date(d).valueOf())
       //     if(a.data){
       //       b=true
       //     }else{
       //       b=false
       //     }
       //     console.log('b',b)
       //     return a
       //   }
       //
       //   let a=isTask(date)
       //    return false
       // }

    },
    /**
     * 是否显示日程表详细内容（为false则显示白板）
     */
    show() {
      return this.phases && this.phases.length > 0
    },
    /**
     * 当前地块id
     */
    landId() {
      return this.plan.landId
    },
  },
  methods: {
    /**
     * 写入当前地块的种植计划信息，供父组件调用
     */
    setPlan(plan) {
      this.plan = plan
      this.planning = typeof plan.planId === 'number'
      // 当有种植计划的情况下，马上初始化日程表，否则要等表单做出选择之后，才刷新日程表
      if (this.planning) {
        // 请求种植计划的阶段phases
        getPhasesOfPlan(plan.planId).then((resp) => {
          console.log('查询的阶段',resp)
          this.setPhases(resp.data)
        })
        // 请求建议
        getSuggestsOfPlan(plan.planId).then((resp) => {
          this.setSuggests(resp.data)
        })
      }
    },
    /**
     * 设置阶段数据。供父组件调用。一旦设置了阶段，那么就会显示日程表，否则显示白板
     */
    setPhases(val) {
      this.phases = val
    },
    /**
     * 设置建议数据。供父组件调用。会把传入的列表式建议，转换为键值映射形式，键就是日期字符串，值是建议的内容，这样便于调用
     */
    setSuggests(val) {
      this.$nextTick(() => {
        this.suggests = val
        console.log('建议：', val)
        const map = {}
        val.forEach((item) => {
          const key = new Date(item.begin).format('yyyy-MM-dd')
          map[key] ? map[key].push(item.content) : (map[key] = [item.content])
        })
        this.suggests = map
      })
    },
    /**
     * 清空。供父组件调用。
     */
    clear() {
      this.phases.length = 0
      this.suggests.length = 0
    },
    /**
     * 计算某天所处阶段
     */
    phase(day) {
      const t = day.getTime()
      const phase = this.phases.find((p) => {
        return t >= p.begin && t < p.end
      })
      console.log(phase)
      if (!phase) return undefined
      // console.log(
      //   day.format('yyyy-MM-dd'),
      //   ' VS. ',
      //   new Date(phase.begin).format('yyyy-MM-dd')
      // )
      const isBegin =
        day.format('yyyy-MM-dd') === new Date(phase.begin).format('yyyy-MM-dd')
      return {
        index: phase.index,
        name: phase.name,
        isBegin,
        badge: isBegin ? phase.badge : undefined,
      }
    },
    /**
     * 点击了“工作安排”按钮，触发某一天的任务编辑
     */
    work(date) {
      let option = {}
      option.suggests = this.suggests
      this.$emit('work', {
        date: date,
        suggest: this.suggests[new Date(date).format('yyyy-MM-dd')],
      })
    },
  },
}
</script>

<style scoped>
.current-month {
  color: #666;
}
</style>

<style>
#plan-detail div.el-calendar-day {
  padding: 4px;
}

#plan-detail div.el-calendar-day .work {
  visibility: hidden;
}
#plan-detail div.el-calendar-day:hover .work {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/product/plan/PlanDetailCalendar.vue